<template>
  <div id="transferMenu">
    <div
      class="confirm"
    >
      <p><strong>Transfer '{{ transferItem.name }}' to Farm:</strong></p>
      <div>
        <b-form-select
          v-model="selectedFarm"
          :options="$store.state.farms"
          text-field="name"
          value-field="id"
        ></b-form-select>
      </div>
      <button
        class="btn btn-success mr-1 mt-3"
        @click="confirmTransfer = true"
        v-if="this.selectedFarm"
      >
        Transfer
      </button>
      <button
        class="btn btn-secondary mt-3"
        @click="$store.commit('setStateProperty', { property: 'transferMenuOpen', value: false })"
      >
        Cancel
      </button>
    </div><!-- /.confirm -->
    <Confirm
      v-if="confirmTransfer"
      text="Are you sure you want to transfer this dataset to the root of the selected farm? If this is a dynamic dataset, this will also transfer its associated data collector."
      v-on:confirmed="transfer($event)"
    />
  </div><!-- /#confirm -->
</template>

<script>
import Confirm from '../Confirm'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      selectedFarm: false,
      confirmTransfer: false
    }
  },
  components: {
    Confirm
  },
  props: [
    'transferItem'
  ],
  methods: {
    transfer (confirm) {
      if (confirm) {
        console.log(this.selectedFarm)
        console.log(this.transferItem)
        if (this.transferItem.dynamic) {
          // Update Collector
          fb.collectorsCollection.doc(this.transferItem.collectorId).update({
            farmId: this.selectedFarm,
            updatedOn: new Date(),
            updatedBy: this.$store.state.currentUser.uid
          })
        }
        // Update Dataset then close
        fb.datasetsCollection.doc(this.transferItem.id).update({
          farmId: this.selectedFarm,
          folderId: 'root',
          updatedOn: new Date(),
          updatedBy: this.$store.state.currentUser.uid
        }).then(() => {
          this.$store.commit('setAlert', { active: true, message: 'Successfully transfered dataset!', level: 'alert-success', timeout: 5000 })
          this.confirmTransfer = false
          this.$store.commit('setStateProperty', { property: 'transferMenuOpen', value: false })
          this.$store.dispatch('refreshFarm')
        })
      } else {
        this.confirmTransfer = false
      }
      // fb.datasetsCollection.doc(this.moveItem.id).update({
      //   createdOn: new Date(),
      //   updatedOn: new Date(),
      //   folderId: this.$store.state.folder.id
      // }).then(() => {
      //   this.$store.commit('setStateProperty', { property: 'moveMenuOpen', value: false })
      //   this.$store.dispatch('fetchDatasets', this.$store.state.farm.id).then(() => {
      //     this.$store.dispatch('fetchFolders', this.$store.state.farm.id)
      //   })
      // })
    }
  }
}
</script>

<style scoped>
#transferMenu {
  position: absolute;
  padding: 20px;
  border-radius: 4px;
  z-index: 999;
  top: 120px;
  left: 80px;
  width: 300px;
  background-color: #eee;
  box-shadow: 1px 2px 3px rgba(0,0,0,0.4);
}
</style>
